module.exports = __webpack_public_path__ + "media/app/images/retina-bckg-f787b4158e84115a9b886d6d977d169c.png";